
import React, { useState } from "react";
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Dialog,
} from "@mui/material";
import {
  Home as HomeIcon,
  AccountCircle as ProfileIcon,
  LibraryBooks as TestIcon,
  Palette as ThemeIcon,
  CardGiftcardOutlined,
  Settings as SettingsIcon,
  Description as TermsIcon,
  Lock as PrivacyIcon,
  Article as NewsIcon,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import logoImg from "../static/img/header/logo.svg";
import GamezTips from "../components/GamezTips";
import TestSkillsDialog from "../components/TestSkillsDialog";
import GiftCard from "../components/GiftCard"; // ✅ Added import
import EggGiftCard from "../components/EggGiftCard";

const LayoutDesktop = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  const [openTestSkills, setOpenTestSkills] = useState(false);
  const [openEggCard, setOpenEggCard] = useState(false);

  const skillLevel = sessionStorage.getItem("skillLevel") || "beginner";
   // 🔹 [ADDED: Lines 39–42] Hide layout completely for Unity game route

   if (location.pathname === "/ga-fps") {
    return <>{children}</>;
  }

  const isFpsGamePath = location.pathname === "/ga-fps-game";

  const NavItem = ({ to, icon: Icon, label, onClick }) => (
    <ListItem
      onClick={onClick}
      component={to ? Link : "div"}
      to={to}
      sx={{
        color: location.pathname === to ? "#FFD700" : "text.primary",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <ListItemIcon>
        <Icon
          sx={{ color: location.pathname === to ? "#FFD700" : "inherit" }}
        />
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden", gap: 2 }}>
        <Paper
          elevation={3}
          sx={{
            width: 240,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: 2,
          }}
        >
          <img
            src={logoImg}
            alt="GamezAcademy"
            style={{ height: "auto", width: "130px" }}
          />
          <List component="nav" sx={{ width: "100%" }}>
            <NavItem to="/" icon={HomeIcon} label="Home" />
            <NavItem to="/news" icon={NewsIcon} label="News" />
            <NavItem to="/profile" icon={ProfileIcon} label="Profile" />
            <NavItem
              to={null}
              onClick={(e) => {
                e.preventDefault();
                setOpenTestSkills(true);
              }}
              icon={TestIcon}
              label="Test your Skills"
            />
            <NavItem
              to="/puzzle"
              icon={CardGiftcardOutlined}
              label="Win a Gift"
            />

            {/* <NavItem to="/appearance-theme" icon={ThemeIcon} label="Appearance Theme" /> */}

            <Divider sx={{ my: 1 }} />

            {/* <NavItem to="/settings" icon={SettingsIcon} label="Settings" /> */}
            <NavItem to="/terms" icon={TermsIcon} label="Terms of Service" />

            {/* ✅ GiftCard with Watch Now working */}
            <Box sx={{ p: 1 }}>
              <GiftCard onWatchNow={() => setOpenEggCard(true)} />
            </Box>

            {/* <NavItem to="/privacy" icon={PrivacyIcon} label="Privacy Policy" /> */}
          </List>
        </Paper>
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            backgroundColor: theme.palette.background.paper,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {children}
        </Box>

        {!isFpsGamePath && (
          <Paper
            elevation={3}
            sx={{
              width: 240,
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: 2,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
            }}
          >
            <GamezTips skillLevel={skillLevel} />
          </Paper>
        )}
      </Box>

      {/* ✅ Directly render EggGiftCard */}
<EggGiftCard
  open={openEggCard}
  onClose={() => setOpenEggCard(false)}
  onStart={() => {
    setOpenEggCard(false);
    alert("Starting...");
  }}
/>



      <TestSkillsDialog
        open={openTestSkills}
        onClose={() => {
          setOpenTestSkills(false);
        }}
      />
    </Box>
  );
};

export default LayoutDesktop;